/**
 * Composable for forward and reverse geocoding using Mapbox
 */
export function useGeocoding(mapboxToken) {
  const forwardGeocode = async (address) => {
    if (!address.trim() || !mapboxToken) {
      return null;
    }

    try {
      const response = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(address)}.json?access_token=${mapboxToken}&limit=1`
      );

      const data = await response.json();

      if (data.features && data.features.length > 0) {
        const feature = data.features[0];
        const [lng, lat] = feature.center;
        return {
          lat,
          lng,
          address: feature.place_name || address
        };
      }
      return null;
    } catch (error) {
      console.error('Error forward geocoding:', error);
      return null;
    }
  };

  const reverseGeocode = async (lat, lng) => {
    if (!mapboxToken) {
      return null;
    }

    try {
      const response = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?access_token=${mapboxToken}&limit=1`
      );

      const data = await response.json();

      if (data.features && data.features.length > 0 && data.features[0].place_name) {
        return data.features[0].place_name;
      }
      return null;
    } catch (error) {
      console.error('Error reverse geocoding:', error);
      return null;
    }
  };

  return {
    forwardGeocode,
    reverseGeocode
  };
}

